import { useEffect } from 'react'

export const useCountryFetcher = (serviceUrlCountries, setCountries) => {
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await fetch(serviceUrlCountries)
        if (!res.ok) throw new Error("Failed to fetch countries")
        const data = await res.json()

        if (data.priorityCountries && data.otherCountries) {
          const sortedCountries = [
            ...data.priorityCountries,
            { value: '', label: '--------', disabled: true },
            ...data.otherCountries
          ]
          setCountries(sortedCountries)
        }
      } catch (err) {
        console.error('Error fetching countries:', err)
      }
    }

    fetchCountries()
  }, [])
}